import { RETURN_REASON } from '../constants';
import { CreateReturnOrderLineItem } from '../redux/types';

export const getReturnReason = (line: CreateReturnOrderLineItem): string => {
    const returnReason = normalizeReturnReason(line.returnReason);

    if (returnReason === RETURN_REASON.OTHER) {
        return line.customReason?.trim() || RETURN_REASON.NONE;
    }

    return returnReason;
};

export const normalizeReturnReason = (reason: string | undefined): RETURN_REASON => {
    if (!reason) {
        return RETURN_REASON.NONE;
    }

    const normalized = reason.trim().toUpperCase();
    return Object.values(RETURN_REASON).includes(normalized as RETURN_REASON)
        ? (normalized as RETURN_REASON)
        : RETURN_REASON.NONE;
};

export const isNormalizedReturnReason = (reason: string): boolean => {
    if (!reason) return false;

    const normalized = reason.trim().toUpperCase();
    return Object.values(RETURN_REASON).includes(normalized as RETURN_REASON);
};
